import { SCALE } from '@ahmdigital/constants';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import type { GetServerSideProps } from 'next';

import { CONSIDERATION_CONTENT_SLUGS } from '../../../src/client/ahm-constants/ui';
import ConsiderationLandingPageTemplate, {
  ConsiderationLandingPageProps,
  getTemplateServerSideProps,
} from '../../../components/page-templates/consideration-landing-page-template';
import customerActions from '../../../src/client/actions/customer';

const slug = CONSIDERATION_CONTENT_SLUGS.FAMILY_COVER_LANDING_PAGE;

const FamilyCoverPage = ({
  activeOffers: serverSideOffers,
  placeholders: serverSidePlaceholders,
  serverSideData,
}: ConsiderationLandingPageProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(customerActions.changeScale(SCALE.FAMILY));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ConsiderationLandingPageTemplate
      activeOffers={serverSideOffers}
      placeholders={serverSidePlaceholders}
      serverSideData={serverSideData}
      slug={slug}
    />
  );
};

export const getServerSideProps: GetServerSideProps = getTemplateServerSideProps({ slug });

export default FamilyCoverPage;
